var r="@hpstellar/core/care-pack";export{r as carePackTestId};
